/* eslint-disable no-duplicate-case */
import * as types from '../constants';
import { STATUS } from '../constants';
import { reject, resolve } from '../api';

export const initialBulkDataState = {
  bulkDataFeeds: [],
  bulkDataFeedsStatus: STATUS.IDLE,
  bulkDataFeedOptions: [],
  bulkDataFeedOptionsStatus: STATUS.IDLE,
  bulkDataDownloadStatus: STATUS.IDLE,
  bulkDataDownloadLink: '',
};

export default (state = initialBulkDataState, action) => {
  switch (action?.type) {
    case types.LOAD_BULK_DATA_FEEDS: {
      return {
        ...state,
        bulkDataFeedsStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_BULK_DATA_FEEDS): {
      return {
        ...state,
        bulkDataFeedsStatus: STATUS.LOADED,
        bulkDataFeeds: action?.payload,
      };
    }

    case types.LOAD_BULK_DATA_FEED_OPTIONS: {
      return {
        ...state,
        bulkDataFeedOptionsStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_BULK_DATA_FEED_OPTIONS): {
      return {
        ...state,
        bulkDataFeedOptionsStatus: STATUS.LOADED,
        bulkDataFeedOptions: action?.payload,
      };
    }

    case types.DOWNLOAD_BULK_DATA_FEED: {
      return {
        ...state,
        bulkDataDownloadStatus: STATUS.LOADING,
        bulkDataDownloadLink: action?.payload,
      };
    }
    case resolve(types.DOWNLOAD_BULK_DATA_FEED): {
      return {
        ...state,
        bulkDataDownloadStatus: STATUS.LOADED,
        bulkDataDownloadLink: action?.payload,
      };
    }

    case types.CLEAR_BULK_DATA_FEEDS: {
      return {
        ...state,
        bulkDataDownloadStatus: STATUS.IDLE,
        bulkDataDownloadLink: '',
      };
    }

    default:
      return state;
  }
};
